import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: Record<string, MessageDescriptor> = defineMessages({
	cardTitle: {
		id: 'ai-mate.message-actions.scheduled-chat.card-title',
		defaultMessage: 'Scheduled chat',
		description: 'Title for the scheduled chat action card in the conversation assistant.',
	},
	scheduledChatNameLabel: {
		id: 'ai-mate.message-actions.scheduled-chat.name-label',
		defaultMessage: 'Scheduled name',
		description: 'Label for the required name field of a scheduled chat.',
	},
	scheduledChatNamePlaceholder: {
		id: 'ai-mate.message-actions.scheduled-chat.name-placeholder',
		defaultMessage: 'Enter a name for this scheduled chat',
		description: 'Placeholder for the scheduled chat name field.',
	},
	promptLabel: {
		id: 'ai-mate.message-actions.scheduled-chat.prompt-label',
		defaultMessage: 'Prompt',
		description: 'Label for the prompt textarea in the scheduled chat form.',
	},
	promptPlaceholder: {
		id: 'ai-mate.message-actions.scheduled-chat.prompt-placeholder',
		defaultMessage: 'Enter the prompt for this scheduled chat',
		description: 'Placeholder for the scheduled chat prompt field.',
	},
	frequencyLabel: {
		id: 'ai-mate.message-actions.scheduled-chat.frequency-label',
		defaultMessage: 'Frequency',
		description: 'Label for the schedule frequency dropdown.',
	},
	frequencyOptionHourly: {
		id: 'ai-mate.message-actions.scheduled-chat.frequency-option.hourly',
		defaultMessage: 'Hourly',
		description: 'Frequency option in the scheduled chat schedule row.',
	},
	frequencyOptionDaily: {
		id: 'ai-mate.message-actions.scheduled-chat.frequency-option.daily',
		defaultMessage: 'Daily',
		description: 'Frequency option in the scheduled chat schedule row.',
	},
	frequencyOptionWeekdays: {
		id: 'ai-mate.message-actions.scheduled-chat.frequency-option.weekdays',
		defaultMessage: 'Weekdays',
		description: 'Frequency option in the scheduled chat schedule row.',
	},
	frequencyOptionCustom: {
		id: 'ai-mate.message-actions.scheduled-chat.frequency-option.custom',
		defaultMessage: 'Custom',
		description: 'Frequency option in the scheduled chat schedule row.',
	},
	daysLabel: {
		id: 'ai-mate.message-actions.scheduled-chat.days-label',
		defaultMessage: 'Days',
		description: 'Label for selected days in the custom schedule configuration.',
	},
	timeLabel: {
		id: 'ai-mate.message-actions.scheduled-chat.time-label',
		defaultMessage: 'Time',
		description:
			'The text is shown as a label for the time picker input field in the scheduled chat creation or edit form.',
	},
	createButton: {
		id: 'ai-mate.message-actions.scheduled-chat.create-button',
		defaultMessage: 'Create',
		description: 'Create button for the scheduled chat form.',
	},
	saveButton: {
		id: 'ai-mate.message-actions.scheduled-chat.save-button',
		defaultMessage: 'Save',
		description: 'Save button for the scheduled chat edit modal.',
	},
	cancelButton: {
		id: 'ai-mate.message-actions.scheduled-chat.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Cancel button for the scheduled chat edit modal.',
	},
	createModalTitle: {
		id: 'ai-mate.message-actions.scheduled-chat.create-modal-title',
		defaultMessage: 'Create scheduled chat',
		description: 'Modal title for creating a scheduled chat.',
	},
	editModalTitle: {
		id: 'ai-mate.message-actions.scheduled-chat.edit-modal-title',
		defaultMessage: 'Edit scheduled chat',
		description: 'Modal title for editing a scheduled chat.',
	},
	renameModalTitle: {
		id: 'ai-mate.message-actions.scheduled-chat.rename-modal-title',
		defaultMessage: 'Rename scheduled chat',
		description: 'Modal title when renaming a scheduled chat from the list.',
	},
	editModalPause: {
		id: 'ai-mate.message-actions.scheduled-chat.edit-modal-pause',
		defaultMessage: 'Pause scheduled chat',
		description: 'Label for the pause toggle in the edit modal.',
	},
	editModalNextRunAt: {
		id: 'ai-mate.message-actions.scheduled-chat.edit-modal-next-run-at',
		defaultMessage: 'Next run {nextRunLabel}',
		description:
			'Subtitle in the scheduled chat edit modal header showing when the chat will run next.',
	},
	frequencyAtTime: {
		id: 'ai-mate.message-actions.scheduled-chat.frequency-at-time',
		defaultMessage: '{frequency} at {time}',
		description:
			'Frequency + time-of-day used in scheduled-chat surfaces (e.g. preview card "Repeats" row), e.g. "Daily at 9:00 AM".',
	},
	dateAtTime: {
		id: 'ai-mate.message-actions.scheduled-chat.date-at-time',
		defaultMessage: '{date} at {time}',
		description:
			'Date + time-of-day used in scheduled-chat surfaces (e.g. preview card "Next run" row, edit modal subtitle), e.g. "12 May at 9:00 AM".',
	},
	editModalDelete: {
		id: 'ai-mate.message-actions.scheduled-chat.edit-modal-delete',
		defaultMessage: 'Delete',
		description:
			'The text is shown on a danger button in the scheduled chat edit modal that permanently deletes the scheduled chat when clicked.',
	},
	deleteModalTitle: {
		id: 'ai-mate.message-actions.scheduled-chat.delete-modal.title',
		defaultMessage: 'Delete scheduled chat?',
		description: 'Title for the delete confirmation modal.',
	},
	deleteModalDescription: {
		id: 'ai-mate.message-actions.scheduled-chat.delete-modal.description',
		defaultMessage: 'Are you sure you want to delete "{name}"? This action cannot be undone.',
		description: 'Description text for the delete confirmation modal.',
	},
	deleteModalCancel: {
		id: 'ai-mate.message-actions.scheduled-chat.delete-modal.cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button label in the delete confirmation modal.',
	},
	deleteModalConfirm: {
		id: 'ai-mate.message-actions.scheduled-chat.delete-modal.confirm',
		defaultMessage: 'Delete',
		description: 'Confirm delete button label in the delete confirmation modal.',
	},
});

export default messages;
